import { render, staticRenderFns } from "./NotificationFloatingWrapper.vue?vue&type=template&id=0b06fe38&scoped=true"
import script from "./NotificationFloatingWrapper.vue?vue&type=script&lang=js"
export * from "./NotificationFloatingWrapper.vue?vue&type=script&lang=js"
import style0 from "./NotificationFloatingWrapper.vue?vue&type=style&index=0&id=0b06fe38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b06fe38",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NotificationFloating: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/notification/NotificationFloating.vue').default})
